import { useContext, useEffect, useState } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import IconButton from "../../components/ButtonIcon";
import PageTitle from "../../components/PageTitle";
import CaixaTextoInputIcone from "../../components/TextBoxIcon";
import { GlobalContext } from "../../contexts/global";
import { formatMoneyBRL, lastDayMonth } from "../../helpers/util";
import { GetTablePrice, GetTablePriceDetails } from "../../services/Api/tablePrice";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import TablePrice from "./components/TablePrice";
import ButtonIcon from "../../components/ButonIcon";
import { IS_WEB } from "@services/Config";



export default function Contract({ navigation, route }) {
  const [selectedTablePrice, setSelectedTablePrice] = useState("");
  const [selectedTablePriceDetails, setSelectedTablePriceDetails] = useState("");
  const [amountSpace, setAmountSpace] = useState(1);
  const [tablePriceList, setTablePriceList] = useState([])
  const params = route.params
  const idUnity = params.id
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);


  useEffect(() => setLoading({ show: true, message: "Carregando tabelas de preço" }), [])

  useEffect(() => {
    GetTablePrice(idUnity).then((value) => {
      setTablePriceList(value)
    }).catch((value) => {
      setShowAlert({
        type: "alert",
        title: "Erro ao carregar tabelas de preço",
        message: value.erro ? value.erro : "Não informado",
        show: true,
        confirmText: "OK",
        pressConfirm: () => {
          setShowAlert({ ...showAlert, show: false });
        },
      });
    }).finally(() => {
      setLoading({ show: false, message: "" })
    })
  }, [])


  useEffect(() => {
    if (!!selectedTablePrice) {
      if (!isNaN(selectedTablePrice.value.id))
        GetTablePriceDetails(idUnity, selectedTablePrice.value.id).then((value) => {
          setSelectedTablePriceDetails(value)
        }).catch((value) => {
          setShowAlert({
            type: "alert",
            title: "Erro ao carregar detalges da tabela de preço",
            message: value.erro ? value.erro : "Não informado",
            show: true,
            confirmText: "OK",
            pressConfirm: () => {
              setShowAlert({ ...showAlert, show: false });
            },
          });
        })
    }
  }, [selectedTablePrice])


  const [validSelectedTablePrice, setValidSelectedTablePrice] = useState({
    isValid: true,
    invalidMessage: "Selecione uma tabela de preço válida",
  });

  const [validAmountSpace, setValidAmountSpace] = useState({
    isValid: true,
    invalidMessage: "Digite uma quantidade válida",
  });

  const amountSpot = isNaN(amountSpace) ? 0 : amountSpace;
  const now = new Date();
  const dayPrice = selectedTablePriceDetails.data ? selectedTablePriceDetails.data.find((day) => day.day == now.getDate()) :
    { price: 0, netPrice: 0, proportionalValue: 0 }
  const totalPerSpace = dayPrice.price
  const totalAmount = totalPerSpace * amountSpot;
  const proportionalValue = dayPrice.proportionalValue
  const netPrice = dayPrice.netPrice
  // const currentDay = now.getDate().toString().padStart(2, "0");
  // const lastDay = lastDayMonth(now.getFullYear(), now.getMonth());
  // const month = (now.getMonth() + 1).toString().padStart(2, "0");

  const nextNow = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  // const lastDayNextMonth = lastDayMonth(
  //   nextNow.getFullYear(),
  //   nextNow.getMonth()
  // );
  // const nextDay = nextNow.getDate().toString().padStart(2, "0");
  // const nextMonth = (nextNow.getMonth() + 1).toString().padStart(2, "0");


  const onPressContract = () => {
    let valid = true;
    if (selectedTablePrice) {
      if (!selectedTablePrice.value) {
        valid = false;
        setValidSelectedTablePrice({
          ...validSelectedTablePrice,
          isValid: false,
        });
      } else {
        if (isNaN(selectedTablePrice.value.id)) {
          valid = false;
          setValidSelectedTablePrice({
            ...validSelectedTablePrice,
            isValid: false,
          });
        }
        setValidSelectedTablePrice({ ...validSelectedTablePrice, isValid: true });
      }
    } else {
      valid = false;
      setValidSelectedTablePrice({
        ...validSelectedTablePrice,
        isValid: false,
      });
    }

    if (isNaN(amountSpace)) {
      valid = false;
      setValidAmountSpace({ ...validAmountSpace, isValid: false });
    } else {
      if (amountSpace <= 0) {
        valid = false;
        setValidAmountSpace({
          invalidMessage: "Digite uma quantidade maior que 0",
          isValid: false,
        });
      } else {
        setValidAmountSpace({ ...validAmountSpace, isValid: true });
      }
    }

    if (totalAmount <= 0) {
      valid = false;
      setShowAlert({
        type: "warning",
        title: "Valores incorretos",
        message: "Verifique a tabela de preço e a quantidade de vagas",
        show: true,
        confirmText: "OK",
        pressConfirm: () => {
          setShowAlert({ ...showAlert, show: false });
        },
      });
    }

    if (valid) {
      navigation.navigate("PaymentContract", {
        totalAmount: totalAmount.toFixed(2),
        amountSpace: amountSpace,
        tablePrice: selectedTablePrice,
        dayPrice: dayPrice,
        unityName: route.params.name,
        unityId: idUnity
      })
    }
  };

  return (
    <PageTitle title={"MENSALISTA"} navigation={navigation} onClickDimmisKeyboard={!IS_WEB}>

      <View style={styles.viewIcon}>
        <Icon size={32} name={"map-marker-outline"} />
        <Text style={styles.unityName}>{route.params.name}</Text>
      </View>
      <KeyboardAwareScrollView
        style={{ flex: 1, flexGrow: 1, backgroundColor: Colors.WHITE }}
        keyboardShouldPersistTaps={"always"}
      >
        <Text style={styles.titleText}>{"TABELA DE PREÇO"}</Text>
        <View style={styles.viewSubdata}>
          <TablePrice
            select={selectedTablePrice}
            setSelected={setSelectedTablePrice}
            {...validSelectedTablePrice}
            tableList={tablePriceList.data}
          />
        </View>
        <Text style={styles.titleText}>{"QUANTIDADE DE VAGAS"}</Text>
        <View style={[styles.viewSubdata, { flexDirection: "row", justifyContent: "center" }]}>
          {/* <CaixaTextoInputIcone
            placeholderInput={"0"}
            keyboardType={"numeric"}
            onChangeTextInput={(amountSpace) => setAmountSpace(amountSpace)}
            maxLength={200}
            value={amountSpace}
            {...validAmountSpace}
            styleBox={{ width: "100%", marginBottom: 0 }}
          /> */}
          <ButtonIcon iconName={"minus-thick"}
            size={20}
            colorButton={Colors.ALERT} style={{ marginRight: 32, borderRadius: 64 }}
            onPress={() => setAmountSpace(amountSpace > 1 ? amountSpace - 1 : 1)} />
          <Text style={styles.amountText}>{amountSpace}</Text>
          <ButtonIcon iconName={"plus-thick"}
            size={20}
            colorButton={Colors.ALERT}
            style={{ marginLeft: 32, borderRadius: 64 }}
            onPress={() => setAmountSpace(amountSpace < 10 ? amountSpace + 1 : amountSpace)} />

        </View>
        <Text style={styles.titleText}>{"VALORES POR VAGA"}</Text>
        <View style={styles.viewSubdata}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-around",
              width: "100%",
            }}
          >
            <View style={styles.totalView}>
              <Text style={styles.totalText}>{"Proporcional"}</Text>
              {/* <Text
                style={[
                  styles.totalText,
                  {
                    fontSize: Fonts.FONT_SIZE_16,
                    color: Colors.BLACK,
                    fontWeight: "500",
                  },
                ]}
              >{`${currentDay}/${month} a ${lastDay}/${month}`}</Text> */}
              <Text style={styles.valueText}>
                {formatMoneyBRL(proportionalValue)}
              </Text>
            </View>
            {totalPerSpace > netPrice ? <View style={styles.totalView}>
              <Text style={styles.totalText}>{"Próximo mês"}</Text>
              {/* <Text
                style={[
                  styles.totalText,
                  {
                    fontSize: Fonts.FONT_SIZE_16,
                    color: Colors.BLACK,
                    fontWeight: "500",
                  },
                ]}
              >{`${nextDay}/${nextMonth} a ${lastDayNextMonth}/${nextMonth}`}</Text> */}
              <Text style={styles.valueText}>
                {formatMoneyBRL(netPrice)}
              </Text>
            </View> : null}
          </View>
        </View>
        <TouchableOpacity style={styles.infoView} onPress={() => {
          if (totalPerSpace > 0) navigation.navigate("InfoTable", { tablePrice: selectedTablePrice.value, proportionalTable: selectedTablePriceDetails.data })
        }}>
          <Text style={styles.titleText}>{"INFORMAÇÕES"}</Text>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginLeft: "auto",
            }}
          >
            <Icon
              name="chevron-right"
              size={28}
              onPress={() => {
                if (totalPerSpace > 0) navigation.navigate("InfoTable", { tablePrice: selectedTablePrice.value, proportionalTable: selectedTablePriceDetails.data })
              }}
            />
          </View>
        </TouchableOpacity>
      </KeyboardAwareScrollView>
      <View style={styles.totalPayView}>
        <Text style={styles.totalPayLabel}>{"Total a pagar"}</Text>
        <Text style={styles.totalPayValue}>{formatMoneyBRL(totalAmount)}</Text>
      </View>
      <IconButton
        textoBotao={"Contratar"}
        iconName={"plus-circle-outline"}
        estilo={{ backgroundColor: Colors.SUCCESS, width: "100%", marginTop: 16, }}
        onPress={() => onPressContract()}
      />
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  viewSubdata: {
    padding: 4,
    backgroundColor: Colors.SNOW,
    borderColor: Colors.SECONDARY,
    borderLeftWidth: 2,
    shadowColor: Colors.GRAY_DARK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
  },
  titleText: {
    color: Colors.SECONDARY,
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "bold",
    marginVertical: 8,
  },
  viewIcon: {
    alignItems: "center",
    justifyContent: "center",
    padding: 8,
    flexDirection: "row",
  },
  unityName: {
    fontSize: Fonts.FONT_SIZE_16,
    marginLeft: 4,
  },
  totalText: {
    fontWeight: "bold",
    fontSize: Fonts.FONT_SIZE_18,
  },
  valueText: {
    fontSize: Fonts.FONT_SIZE_18,
    color: Colors.PRIMARY,
  },
  totalView: {
    justifyContent: "center",
    alignItems: "center",
  },
  totalPayLabel: {
    color: Colors.BLACK,
    fontSize: Fonts.FONT_SIZE_16,
    fontWeight: "bold",
  },
  totalPayValue: {
    fontSize: Fonts.FONT_SIZE_28,
    fontWeight: "bold",
    color: Colors.PRIMARY,
    textAlignVertical: "bottom",
  },
  totalPayView: {
    justifyContent: "flex-end",
    alignItems: "flex-start",
    margin: 4,
    marginBottom: 0,
    alignSelf: "stretch",
  },
  infoView: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: Colors.GRAY_LIGHT,
    borderRadius: 8,
    marginVertical: 16,
    padding: 8,
    borderLeftWidth: 2,
    borderTopLeftRadius: 0,
    borderBottomStartRadius: 0,
    borderColor: Colors.SECONDARY,
  },
  amountText: {
    fontSize: Fonts.FONT_SIZE_24,
    color: Colors.BLACK,
    fontWeight: "500"
  }
});
